module.exports = __webpack_public_path__ + "static/media/reedMWK1007.7f59f176.ico";